module.exports = __webpack_public_path__ + "img/icon_map.61d88c7a.svg";